/**
 * Base graph types from @engine/graph.
 *
 * This module re-exports the core graph types for use in Redprint.
 *
 * Usage within redprint:
 *   import { Graph } from './base';
 *   import type { NodeInstance, GraphData } from '../types';
 */

// Re-export core types
export type {
  Vec2,
  PortRef,
  Edge,
  BaseNodeInstance,
  BaseGraphVariable,
  BaseGraphData,
  GraphMetadata,
  PortDirection,
  BasePortDefinition,
  BaseNodeDefinition,
  StickyNote,
  NodeGroup,
  GraphDiagnostic,
} from '@engine/graph';

// Re-export uid utilities
export {
  uid,
  resetUidCounter,
} from '@engine/graph';

// Re-export serialization
export {
  serializeGraph,
  deserializeGraph,
  graphToJSON,
  graphFromJSON,
} from '@engine/graph';
export type {
  SerializedGraph,
  SerializedNode,
  SerializedEdge,
  SerializedVariable,
} from '@engine/graph';

// Re-export validation
export {
  GraphValidator as BaseGraphValidator,
  topologicalSort,
} from '@engine/graph';
export type {
  ValidationResult,
  NodeDefinitionResolver,
  ConnectionCheck,
  CanConnectFn,
  ValidatorOptions,
} from '@engine/graph';

// Re-export Graph class directly
// Users should use Graph<NodeInstance, GraphVariable> for Redprint graphs
export { Graph } from '@engine/graph';